var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvdisableView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 48095583"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624129",
    width: 40,
    height: 40,
    rx: 4,
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 13C15 13 10.73 16.11 9 20.5C10.73 24.89 15 28 20 28C25 28 29.27 24.89 31 20.5C29.27 16.11 25 13 20 13ZM20 25.5C17.24 25.5 15 23.26 15 20.5C15 17.74 17.24 15.5 20 15.5C22.76 15.5 25 17.74 25 20.5C25 23.26 22.76 25.5 20 25.5ZM20 17.5C18.34 17.5 17 18.84 17 20.5C17 22.16 18.34 23.5 20 23.5C21.66 23.5 23 22.16 23 20.5C23 18.84 21.66 17.5 20 17.5Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvdisableView);
export default __webpack_public_path__ + "static/media/Inv disable View.48ce5f950196b0a9cc8ddbe3f73734f0.svg";
export { ForwardRef as ReactComponent };